import React from 'react';
import {Col} from 'reactstrap';

const CreateNewOtpButton = (props) => {
  return (
    <Col className='resend-btn-container'>
      <div role='button' tabIndex='0' onClick={props.action} className='w-100 d-flex justify-content-center align-items-center'>
        {/* <span className='align-middle'>
          <img src={props.icon} alt={props.alt} />
        </span> */}
        <span
          className='align-middle text-center create-otp-button-description newPurple'
          dangerouslySetInnerHTML={{__html: props.description}}
        />
      </div>
    </Col>
  );
};
export default CreateNewOtpButton;
